import { combineReducers } from "@reduxjs/toolkit";

import loginSlice from "./reducers/loginSlice";
import errorSlice from "./reducers/errorSlice";
import accountSlice from "./reducers/accountSlice";
import objectSlice from "./reducers/objectSlice";


const rootReducer = combineReducers({
  login: loginSlice,
  error: errorSlice,
  account: accountSlice,
  object: objectSlice
});

export default rootReducer;
